module.exports = __webpack_public_path__ + "media/images/manifest/microbius-152-432181ff621acefa80e9cd17c943ef91.png";